export default "__VITE_ASSET__771479a8__"